import { render } from "./DataDexUploads.vue?vue&type=template&id=4c7bb1ba&scoped=true"
import script from "./DataDexUploads.vue?vue&type=script&lang=js"
export * from "./DataDexUploads.vue?vue&type=script&lang=js"

import "./DataDexUploads.vue?vue&type=style&index=0&id=4c7bb1ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7bb1ba"]])

export default __exports__